export const headerColNames = [
  { colName: 'Order #', accessor: 'id' },
  { colName: 'Date of transaction', accessor: 'createdAt' },
  { colName: 'Item name', accessor: 'item_name' },
  { colName: 'Creator', accessor: 'creator' },
  { colName: ' Category', accessor: 'category_name' },
  { colName: 'Item price', accessor: 'salePrice' },
  { colName: 'Payment method', accessor: 'payment_method' },
];
